type AppEnvironment = 'development' | 'staging' | 'production'

const rawEnv = import.meta.env.VITE_APP_ENV?.trim().toLowerCase()

export const appEnvironment: AppEnvironment =
  rawEnv === 'staging' || rawEnv === 'production' || rawEnv === 'development'
    ? rawEnv
    : import.meta.env.DEV
      ? 'development'
      : 'production'

export function logAppEnvironment(): void {
  const frontendUrl = window.location.origin

  console.info(
    `[WeAuto] ambiente=${appEnvironment} host=${frontendUrl} mode=${import.meta.env.MODE}`,
  )

  if (!rawEnv) {
    console.warn('[WeAuto] VITE_APP_ENV não configurado. Usando fallback automático.')
  }
}
